import React from 'react'
import colors from './colors'
import EasingLine from './shapes/easing-line'

function Equator({ x1, x2, y }) {
  return (
    <EasingLine
      x1={x1}
      x2={x2}
      y1={y}
      y2={y}
      stroke={colors.mediumGray}
      strokeWidth="2"
      strokeDasharray="2 3"
    />
  )
}

function almost(a, b) {
  return Math.abs(a - b) <= 15
}

export default function Grid({
  axis,
  scaleX,
  scaleY,
  ticksX,
  ticksY,
  equator
}) {
  const offset = 'bandwidth' in scaleX ? scaleX.bandwidth() / 2 : 0

  const [left, right] = scaleX.range()
  const [bottom, top] = scaleY.range()

  const columns = ticksX.map(function(tick, i) {
    const x = scaleX(tick) + offset
    const opacity = almost(x, left) || almost(x, right) ? 0 : null

    return (
      <EasingLine
        key={i}
        x1={x}
        x2={x}
        y1={top}
        y2={bottom}
        opacity={opacity}
      />
    )
  })

  const rows = ticksY.map(function(tick, i) {
    const y = scaleY(tick)
    const opacity = almost(y, top) || almost(y, bottom) ? 0 : null

    if (equator && tick === 0) {
      return <Equator key={i} x1={left} x2={right} y={y} />
    }

    return (
      <EasingLine
        key={i}
        x1={left}
        x2={right}
        y1={y}
        y2={y}
        opacity={opacity}
      />
    )
  })

  const className = 'grid ' + axis.join(' ')

  return (
    <g className={className} shapeRendering="crispEdges">
      <g className="grid__frame">
        <EasingLine
          className="grid__frame__top"
          x1={right}
          x2={left}
          y1={top}
          y2={top}
        />
        <EasingLine
          className="grid__frame__bottom"
          x1={right}
          x2={left}
          y1={bottom}
          y2={bottom}
        />
        <EasingLine
          className="grid__frame__right"
          x1={right}
          x2={right}
          y1={top}
          y2={bottom}
        />
        <EasingLine
          className="grid__frame__left"
          x1={left}
          x2={left}
          y1={top}
          y2={bottom}
        />
      </g>
      <g className="grid__columns">{columns}</g>
      <g className="grid__rows">{rows}</g>
    </g>
  )
}

Grid.defaultProps = {
  axis: ['bottom', 'left'],
  equator: false,
  ticksY: [],
  ticksX: []
}



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/charts/grid.js